// APP-01 Home: the apps this person can use (GET /users/me/entitlements).
import { useQuery } from "@tanstack/react-query";
import { Link } from "@tanstack/react-router";
import { api, call } from "../../api/client";
import { useCapabilities } from "../../app/capabilities";
import { visibleNav } from "../../app/nav";
import { PageHeader } from "../../components/PageHeader";
import { Empty, ErrorState, Loading } from "../../components/States";
import { StatusBadge } from "../../components/StatusBadge";

export function HomePage() {
  const { data: caps } = useCapabilities();
  const ents = useQuery({
    queryKey: ["my-entitlements"],
    queryFn: () => call(api.GET("/users/{id}/entitlements", { params: { path: { id: "me" }, query: { limit: 100 } } })),
  });
  const manage = visibleNav(caps).filter((s) => s.id === "admin" || s.id === "ops" || s.id === "dev");

  return (
    <div className="page">
      <PageHeader title="Home" subtitle={caps ? `Signed in as ${caps.email}` : undefined} screenId="APP-01" />
      {manage.length > 0 && (
        <section className="card">
          <h2>Manage</h2>
          <div className="tiles">
            {manage.flatMap((s) => s.items).filter((item) => !item.external).map((item) => (
              <Link key={item.to} to={item.to} className="tile">
                <item.icon size={22} aria-hidden />
                <span>{item.label}</span>
              </Link>
            ))}
          </div>
        </section>
      )}
      <section className="card">
        <h2>Your apps</h2>
        {ents.isPending ? (
          <Loading />
        ) : ents.isError ? (
          <ErrorState error={ents.error} onRetry={() => void ents.refetch()} />
        ) : (ents.data.data ?? []).length === 0 ? (
          <Empty title="No apps yet">When you're given access to an app, it shows up here.</Empty>
        ) : (
          <ul className="app-list">
            {(ents.data.data ?? []).map((e) => (
              <li key={e.id}>
                <span className="app-name">{e.application_id}</span>
                <StatusBadge status={e.status ?? "none"} />
                <span className="muted small">{e.source?.replace("_", " ")}</span>
              </li>
            ))}
          </ul>
        )}
      </section>
    </div>
  );
}
